// Roles shown as their own page under "Users List" (super admin). `key` is the
// /users/:role route param; `uType` is the account type the page is limited to;
// `statKey` is the matching field of the /superadmin/users/list `counts` object
// (used by the "Browse by role" tile grid). `color`/`soft` keep NATURECAMP's own
// teal-led palette - never FILIMSHOOTING's green/purple brand colors.

export const USER_ROLES = [
  { key: "applicants", label: "Applicants", singular: "Applicant", uType: 772, icon: "mdi-account", color: "#64748b", soft: "rgba(100, 116, 139, 0.12)", statKey: "normalUsers" },
  { key: "circle-officers", label: "Circle CCFs", singular: "Circle CCF", uType: 775, icon: "mdi-compass-outline", color: "#0d9488", soft: "rgba(13, 148, 136, 0.12)", statKey: "circles" },
  { key: "dfos", label: "DFOs", singular: "DFO", uType: 774, icon: "mdi-office-building-outline", color: "#13736f", soft: "rgba(19, 115, 111, 0.1)", statKey: "divisions" },
  { key: "section-clerks", label: "DFO Clerks", singular: "DFO Clerk", uType: 7741, icon: "mdi-account-tie", color: "#0891b2", soft: "rgba(8, 145, 178, 0.12)", statKey: "clerks" },
  { key: "superintendents", label: "DFO MHs", singular: "DFO MH", uType: 7742, icon: "mdi-account-star", color: "#d97706", soft: "rgba(217, 119, 6, 0.12)", statKey: "superintendents" },
  { key: "cww-clerks", label: "CWW Clerks", singular: "CWW Clerk", uType: 7771, icon: "mdi-badge-account", color: "#2563eb", soft: "rgba(37, 99, 235, 0.12)", statKey: "adminClerks" },
  { key: "ministerial-heads", label: "CWW MHs", singular: "CWW MH", uType: 7772, icon: "mdi-shield-crown-outline", color: "#4f46e5", soft: "rgba(79, 70, 229, 0.12)", statKey: "ministerial" },
  { key: "dcf", label: "CWW DCF", singular: "CWW DCF", uType: 7773, icon: "mdi-account-star-outline", color: "#ea580c", soft: "rgba(234, 88, 12, 0.12)", statKey: "dcf" },
  { key: "admins", label: "CWW", singular: "CWW", uType: 777, icon: "mdi-shield-account-outline", color: "#9333ea", soft: "rgba(147, 51, 234, 0.12)", statKey: "cwwOnly" },
  { key: "super-admins", label: "Super Admins", singular: "Super Admin", uType: 779, icon: "mdi-shield-crown", color: "#7c3aed", soft: "rgba(124, 58, 237, 0.12)", statKey: "superAdminOnly" },
];

// Roles that sit under a circle (a DFO is a circle's division; its clerk and
// superintendent in turn sit under that division).
export const OFFICIAL_TYPES = [774, 7741, 7742];

// Officials that also belong to a division (a DFO is the division itself).
export const DIVISION_STAFF_TYPES = [7741, 7742];

const DEFAULT_STYLE = { icon: "mdi-account", color: "#64748b", soft: "rgba(100, 116, 139, 0.12)" };

export function getUserRole(key) {
  return USER_ROLES.find((r) => r.key === key) || null;
}

export function getRoleByUType(uType) {
  return USER_ROLES.find((r) => r.uType === Number(uType)) || null;
}

export function roleName(uType) {
  const role = getRoleByUType(uType);
  return role ? role.singular : `Role (${uType})`;
}

export function roleIcon(uType) {
  const role = getRoleByUType(uType);
  return role ? role.icon : DEFAULT_STYLE.icon;
}

export function roleColor(uType) {
  const role = getRoleByUType(uType);
  return role ? role.color : DEFAULT_STYLE.color;
}

export function roleSoft(uType) {
  const role = getRoleByUType(uType);
  return role ? role.soft : DEFAULT_STYLE.soft;
}
